export const REDIRECT_START = 'REDIRECT_START';
export const REDIRECT_CLEAR = 'REDIRECT_CLEAR';
export const SET_HAS_PENDING_CHANGES = 'SET_HAS_PENDING_CHANGES';
export const EXPAND_COLLAPSE = 'EXPAND_COLLAPSE';
export const FETCH_WORKSPACES_DATA = 'FETCH_WORKSPACES_DATA';
export const FETCH_WORKSPACES_DATA_SUCCESS = 'FETCH_WORKSPACES_DATA_SUCCESS';
export const FETCH_WORKSPACES_DATA_FAILURE = 'FETCH_WORKSPACES_DATA_FAILURE';
